import React from 'react';
import styled, { keyframes } from 'styled-components';
import { IconSize, IconType, IconWrap, semanticTheme } from '@tools/ui/dime';

export const AgentAvatarIcon: React.FC = () => (
  <AvatarWrapper>
    <IconWrap type={IconType.AiAgentTopbar} size={IconSize.Medium} />
  </AvatarWrapper>
);

export const AgentDotIcon: React.FC<{ pulsing?: boolean; noData?: boolean }> = ({ pulsing, noData }) => (
  <DotWrapper $pulsing={pulsing} $noData={noData}>
    <IconWrap type={IconType.AiAgentDot} size={IconSize.Small} />
  </DotWrapper>
);

const AvatarWrapper = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 36px;
    height: 36px;
  }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.35); opacity: 0.6; }
`;

const DotWrapper = styled.div<{ $pulsing?: boolean; $noData?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  animation: ${({ $pulsing }) => ($pulsing ? pulse : 'none')} 1.2s ease-in-out infinite;

  svg {
    width: 20px;
    height: 20px;
  }

  ${({ $noData }) =>
    $noData &&
    `
    svg path:first-child {
      fill: ${semanticTheme.dime.colors.fill.secondary};
      fill-opacity: 1;
    }
  `}
`;
